export const quantumPageES = {
  "seo": {
    "title": "LLM Soberanos e IA Cuántica | pAIoneer Labs GmbH",
    "description": "Nuestro objetivo desde Alemania: bajo Veridion («la IA desarrolla aún más la IA»), desarrollar modelos de lenguaje compactos y Quantum Transformers que competirán con los grandes modelos de EE. UU. y China."
  },
  "hero": {
    "kicker": "Made in Germany · La IA desarrolla la IA",
    "title": "LLM Soberanos e IA Cuántica",
    "claim": "Nuestro objetivo desde Alemania: desarrollar nuestros propios modelos de lenguaje y Quantum Transformers, que en el futuro competirán con los grandes modelos de EE. UU. y China.",
    "subtitle": "En proyectos empresariales reales se evaluaron los enfoques europeos actuales — los modelos alemanes de Aleph Alpha (como Kolibri), los modelos franceses en torno a Mistral, EuroLLM y especialmente el modelo suizo Apertus — frente a problemas prácticos de negocio. Ninguno cumple los requisitos de la empresa. Por ello, nuestra IA bajo [Veridion](veridion) («la IA desarrolla aún más la IA») da el siguiente paso: investiga y diseña el camino hacia modelos de lenguaje compactos Made in Germany que serán muy superiores a los modelos franceses, e impulsa como segundo eje sus propios Quantum Transformers.",
    "cta": "Concertar una conversación"
  },
  "pillars": {
    "title": "En qué trabaja nuestra IA",
    "subtitle": "Dos líneas de investigación en las que nuestros colaboradores digitales diseñan nuevas arquitecturas, las prueban en simulador y las construyen paso a paso.",
    "items": [
      {
        "title": "Lo que un modelo debe rendir en el día a día",
        "description": "En el uso productivo cuentan el razonamiento lógico de varios pasos, el uso fiable de herramientas en cadenas largas, el desarrollo de software limpio y los procesos de oficina sin errores. Con ello medimos cada arquitectura desde el inicio."
      },
      {
        "title": "Modelos compactos para la propia infraestructura",
        "description": "En lugar de centros de datos cada vez mayores, nuestra meta será concentrar una alta profundidad de razonamiento en un modelo compacto que las empresas puedan ejecutar localmente en su propio hardware."
      },
      {
        "title": "Quantum Transformers e IA Cuántica",
        "description": "En nuestra segunda línea investigamos cómo combinar arquitecturas transformer con circuitos cuánticos parametrizados y redes tensoriales para abrir nuevas clases de modelos."
      },
      {
        "title": "Quantum IDE propia y procesadores cuánticos reales",
        "description": "En nuestra propia Quantum IDE, nuestros colaboradores de IA diseñan, simulan y prueban nuevos circuitos cuánticos frente a referencias clásicas antes de ejecutarlos en hardware cuántico real."
      }
    ]
  },
  "gate": {
    "title": "Del estado de la investigación al plano constructivo",
    "subtitle": "Cada paso de desarrollo se apoya en literatura verificada, nuestra memoria corporativa y comparaciones medibles.",
    "stages": [
      {
        "step": "Paso 01",
        "title": "Análisis científico y memoria corporativa",
        "description": "Nuestros colaboradores de IA evalúan de forma continua los últimos trabajos científicos sobre arquitecturas lingüísticas y cuánticas, guardando cada hallazgo verificado en el grafo de conocimiento de la empresa."
      },
      {
        "step": "Paso 02",
        "title": "Plan de entrenamiento y simulación de circuitos",
        "description": "Junto con Desarrollo de Producto surge así la hoja de ruta detallada para nuestro futuro modelo de lenguaje, mientras se prueban en paralelo nuevos circuitos en la Quantum IDE."
      },
      {
        "step": "Paso 03",
        "title": "Revisión científica en el proceso IDD",
        "description": "Físicos e investigadores de IA auditan cada hipótesis, medición y diseño mediante [Intent-Driven Development](idd) (IDD) como human-in-the-loop y aprueban el siguiente paso."
      }
    ]
  },
  "stack": {
    "title": "Personas e IA en una misma unidad de investigación",
    "subtitle": "Investigación, desarrollo de producto y supervisión científica se engranan en ciclos fijos.",
    "items": [
      {
        "title": "Investigadores digitales en operación continua",
        "description": "Colaboradores de IA especializados realizan búsqueda bibliográfica, derivaciones matemáticas, diseño de circuitos y evaluación las veinticuatro horas."
      },
      {
        "title": "Físicos en Human-in-the-Loop",
        "description": "Científicos humanos marcan el rumbo de la investigación, cuestionan supuestos y deciden sobre aprobaciones, ejecuciones en hardware y publicaciones."
      },
      {
        "title": "Articulación con Desarrollo de Producto",
        "description": "En estrecha coordinación con nuestro equipo de producto, los resultados validados pasan directamente a nuestras herramientas y futuras soluciones empresariales."
      },
      {
        "title": "Trazable hasta la fuente",
        "description": "Cada decisión de arquitectura, cada variante descartada y cada medición permanece documentada de forma duradera y verificable en todo momento."
      }
    ]
  },
  "cta": {
    "title": "Intercambio sobre investigación",
    "subtitle": "¿Desea intercambiar ideas sobre nuestra investigación en modelos de lenguaje soberanos y Quantum Transformers? Escríbanos.",
    "button": "Escribir mensaje"
  }
};
